import React, {Component} from 'react';
import Card from '../../../CardNew';
import {VOID} from '../../constants';
import CardHelper from '../../../CardNew/helpers';
import './styles.css';
import Translator from 'src/requests/apa/Translator';

class RibbonVoid extends Component {
  constructor(props) {
    super(props);
    this.text = Translator.get(`ribbons_placeholder_${props.placeholder}_label`, "") || Translator.get(`ribbons_placeholder_generic_label`);
    this.focusHandler = props.focusHandler;
    this.data = props.text;
    this.keyDownHandler = props.keyDownHandler;
    this.ribbonIndex = props.ribbonIndex;
    this.ribbonName = props.ribbonName;
  }

  render() {
    let className = '';
    const placeholder = this.props.placeholder;
    if (this.ribbonIndex === 0) {
      className = 'elementopredeterminado';
    }
    const isClassic = this.props.ribbonType === "landscape"
      || this.props.ribbonType === "carousel"
      || this.props.ribbonType === "void";

    const auxRibbonId = this.props.ribbonId
      ? this.props.ribbonId.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase() : ''

    const myRecordings = auxRibbonId === "misgrabaciones";
    const ribbonTypeAboutClassic = isClassic ? "classic" : this.props.ribbonType;
    const validateRibbonType = myRecordings ? "recordings" : ribbonTypeAboutClassic;

    const auxIdCard = `${auxRibbonId}_${validateRibbonType}`;
    const number = this.props.ribbonType === "highlight" ? 2 : 1;
    const id = `${auxIdCard}_link_${number}`

    return (
      <div className="ribbon-items ribbon-void">
        <a
          id={id}
          className={`link ribbon-void-text focusable ${className} elementopredeterminado`}
          data-sn-right='#ribbon-void-text .focusable'
          data-sn-left='#ribbon-void-text .focusable'
          href="javascript:void(0)"
          onBlur={this.unFocusHandler}
          onFocus={() => {
            CardHelper.focusHandler(this.focusHandler, this.data)
          }}
          onKeyDown={e => CardHelper.keyDownHandler(e, this.keyDownHandler, this.data)}
        >
          {this.text}
        </a>
        <Card
          type={VOID} placeholder={placeholder}
        />
        <Card
          type={VOID} placeholder={placeholder}
        />
        <Card
          type={VOID} placeholder={placeholder}
        />
      </div>
    );
  }
}

export default RibbonVoid;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonVoid/index.jsx